import styled from '@emotion/styled';

export const ImgLogo = styled.img`
    width: 100%;
`;
